import React from "react";
import { useNavigate } from "react-router-dom";
import { Typography, Button } from "components";
import { ROUTES } from "../routes/routePaths";
import notFoundImage from "../assets/images/404-image.png";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="d-flex align-items-center flex-column justify-content-center vh-100">
      <img src={notFoundImage} alt="" width="250" />
      <Typography variant="heading3" className={"mt-3"}>
        PAGE NOT FOUND!
      </Typography>
      <Typography>The page you are looking for isn't here</Typography>
      <Typography>We suggest you return to dashboard</Typography>
      <Button
        label="Back to dashboard"
        onClick={() => navigate(ROUTES.dashboard)}
        className={"mt-4"}
      />
    </div>
  );
};

export default NotFound;
